import React, { useEffect } from 'react';
import { useAccount } from 'wagmi';
import { lsKey, useUserContext } from '../context/user.context';

export default function ConnectButton({ title = 'Connect Wallet' }) {
  const { address, isConnected } = useAccount();
  const { setIsLoggedIn } = useUserContext();

  useEffect(() => {
    if (!isConnected && !address) {
      localStorage.removeItem(lsKey);
      setIsLoggedIn(false);
    }
  }, [address, isConnected, setIsLoggedIn]);

  /* @ts-expect-error msg */
  return <appkit-button balance={'hide'} label={title} />;
}
